
import {defineComponent} from "vue";
import CpsOverview from "@/components/layouts/content-pages/overview/CpsOverview.vue";

export default defineComponent({
  name: "ContentPagesOverview",
  components: {CpsOverview},
});
